export default "__VITE_ASSET__BidA1pIo__"